/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Refresh_Success_ToastInputs */

const en_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folders refreshed`)
};

const fr_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dossiers actualises`)
};

const de_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordner aktualisiert`)
};

const it_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartelle aggiornate`)
};

const ru_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Папки обновлены`)
};

const es_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas actualizadas`)
};

const zh_cn2_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件夹已刷新`)
};

const ja_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダが更新されました`)
};

const hi_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर रीफ़्रेश हो गए`)
};

const pt_pt2_explorer_nav_refresh_success_toast = /** @type {(inputs: Explorer_Nav_Refresh_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastas atualizadas`)
};

/**
* | output |
* | --- |
* | "Folders refreshed" |
*
* @param {Explorer_Nav_Refresh_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_refresh_success_toast = /** @type {((inputs?: Explorer_Nav_Refresh_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Refresh_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_refresh_success_toast(inputs)
	if (locale === "de") return de_explorer_nav_refresh_success_toast(inputs)
	if (locale === "it") return it_explorer_nav_refresh_success_toast(inputs)
	if (locale === "ru") return ru_explorer_nav_refresh_success_toast(inputs)
	if (locale === "es") return es_explorer_nav_refresh_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_refresh_success_toast(inputs)
	if (locale === "ja") return ja_explorer_nav_refresh_success_toast(inputs)
	if (locale === "hi") return hi_explorer_nav_refresh_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_refresh_success_toast(inputs)
	return en_explorer_nav_refresh_success_toast(inputs)
});